import React, { Component } from 'react';
import { translate, setLanguage } from 'react-multi-lang';
import { getMenudata } from '../../actions/accountAction';
import store from "../../store";

class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      basePath: window.location.protocol + '//' + window.location.host + '/'
    }
  }
  changeLanguage = (event) => {
    localStorage.setItem('language', event);
    document.documentElement.lang = event;
    store.dispatch(getMenudata())
    setLanguage(event)
  }


  getEnglishStyle = () => {
    return !localStorage.getItem('language') || localStorage.getItem('language') === 'en' ? "#000" : ""
  }

  getPunjabiStyle = () => {
    return localStorage.getItem('language') && localStorage.getItem('language') === 'pu' ? "#000" : ""
  }

  getHindiStyle = () => {
    return localStorage.getItem('language') && localStorage.getItem('language') === 'hi' ? "#000" : ""
  }

  render() {
    return (
      // <li className="list-inline-item">
      //   <span onClick={() => this.changeLanguage('en')} style={{ "color": this.getEnglishStyle(), "cursor": "pointer" }}>English&nbsp;</span>/&nbsp;
      //   <span onClick={() => this.changeLanguage('pu')} style={{ "cursor": "pointer", "color": this.getPunjabiStyle() }}>ਪੰਜਾਬੀ&nbsp;</span>/&nbsp;
      //   <span onClick={() => this.changeLanguage('hi')} style={{ "cursor": "pointer", "color": this.getHindiStyle() }}>हिन्दी</span>
      // </li>
      <li className="list-inline-item" role="listitem">
        <button
          // onClick={() => this.changeLanguage('en')}
          onClick={() => {
            if (window.confirm("This will lead you to English language. Are you sure to switch to this language?")) {
              this.changeLanguage('en');
            }
          }}
          style={{ color: this.getEnglishStyle(), cursor: "pointer", background: "none", border: "none", padding: 0 }}
          lang="en"
          aria-label="Change language to English"
        >
          English
        </button>
        <span aria-hidden="true">&nbsp; / &nbsp;</span>

        <button
          // onClick={() => this.changeLanguage('pu')}
          onClick={() => {
            if (window.confirm("This will lead you to ਪੰਜਾਬੀ language. Are you sure to switch to this language?")) {
              this.changeLanguage('pu');
            }
          }}
          style={{ color: this.getPunjabiStyle(), cursor: "pointer", background: "none", border: "none", padding: 0 }}
          lang="pa"
          aria-label="Change language to Punjabi"
        >
          ਪੰਜਾਬੀ
        </button>
        <span aria-hidden="true">&nbsp; / &nbsp;</span>

        <button
          // onClick={() => this.changeLanguage('hi')}
          onClick={() => {
            if (window.confirm("This will lead you to हिन्दी language. Are you sure to switch to this language?")) {
              this.changeLanguage('hi');
            }
          }}
          style={{ color: this.getHindiStyle(), cursor: "pointer", background: "none", border: "none", padding: 0 }}
          lang="hi"
          aria-label="Change language to Hindi"
        >
          हिन्दी
        </button>
      </li>

    )
  }
}

export default translate(LanguageSelector)

